// extracted by mini-css-extract-plugin
export default {"row":"FederationLoadingRow_row__HsiWj","buildingName":"FederationLoadingRow_buildingName__U+Qo1","chart":"FederationLoadingRow_chart__-FUU8"};